<template>
  <section class="cta pt-9 md:pt-20 lg:pt-36 lg:pb-52 relative">
    <img
      v-if="showScribble"
      src="/frontend/assets/scribble.svg"
      class="hidden lg:block lg:absolute lg:left-1/2 lg:transform lg:-translate-x-1/2 lg:-top-[75px] lg:h-[150px]"
    >

    <div class="container">
      <div class="flex flex-wrap text-center">
        <div class="w-full lg:w-1/2 lg:mx-auto">
          <span class="border border-red px-2 text-xl font-bold mx-auto text-red rounded-md">
            {{ __('components.call-to-action.tag') }}
          </span>
          <h2 class="text-4xl font-bold px-10 text-center mt-4 lg:text-6xl lg:mt-6">
            {{ __('components.call-to-action.title') }}
          </h2>
          <p class="text-gray-300 mt-8 lg:text-xl">
            {{ __('components.call-to-action.text') }}
          </p>

          <div class="text-center mt-12">
            <div>
              <Link
                :href="localeRoute('frontend.business')"
                class="button-black shadow-button-black inline-block"
              >
                {{ __('components.call-to-action.button') }}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>

    <img
      src="/frontend/assets/mobile-cta-img.png"
      class="mt-4 mr-4 lg:absolute lg:bottom-0 lg:left-0 md:w-[350px] lg:w-[400px]"
    >
    <img
      src="/frontend/assets/desktop-cta-img.png"
      class="hidden mt-4 mr-4 md:block md:absolute md:bottom-0 md:right-0 md:w-[220px] lg:w-[310px]"
    >
  </section>
</template>

<script>
export default {
  props: {
    showScribble: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
};
</script>
